export default __webpack_public_path__ + "static/media/891.07c69def.png";